import { Dispatch } from "react";
import { SetStateAction } from "react";

export interface IProps {
  name?: string;
  size?: string;
  placeholder?: string;
  onChange?: (event: Event) => void;
  value?: string;
  hasLabel?: boolean;
  label?: string;
  type?: string;
  labelColor?: string;
  borderRadius?: string;
  inputValue?: string | number;
  setInputValue?: Dispatch<SetStateAction<string>> | void;
  multiline?: boolean;
  height?: string;
  maxRows?: number;
  minRows?: number;
}

export enum InputAtomTypes {
  EMAIL = "email",
  PASSWORD = "password",
  SEARCH = "search",
}
